import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App.jsx';
import './index.css';
import './configs/dayjs.config';
import { installChunkReloadGuard } from './utils/chunkReloadGuard';
import { installPullToRefreshGuard } from './utils/preventPullToRefresh';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  sendDefaultPii: true,
  // Drop errors that originate from browser extensions, WebView wrappers
  // and third-party injected scripts — not application bugs.
  ignoreErrors: [
    'Object Not Found Matching Id', // ORDER-THISWAY-S
    'Invalid call to runtime.sendMessage', // ORDER-THISWAY-19
    'Java object is gone', // ORDER-THISWAY-1S
    'invalid origin', // ORDER-THISWAY-1Q
    "Failed to execute 'removeChild' on 'Node'", // ORDER-THISWAY-1K (Google Translate vs React)
    'window.webkit.messageHandlers', // ORDER-THISWAY-1Y
  ],
  // Drop events whose stack originates from a browser extension URL.
  denyUrls: [
    /chrome-extension:\/\//i,
    /moz-extension:\/\//i,
    /safari-extension:\/\//i,
    /safari-web-extension:\/\//i,
  ],
});

installChunkReloadGuard();
installPullToRefreshGuard();

ReactDOM.createRoot(document.getElementById('root')).render(<App />);
